import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
	selector: 'ras-unit-loading',
	templateUrl: './unit-loading.component.html',
	styleUrls: ['./unit-loading.component.sass']
})
export class UnitLoadingComponent implements OnInit {
	@Output('reload') reloadEventEmitter: EventEmitter<void> = new EventEmitter;
	@Input() failed: boolean = false;

	constructor() { }

	ngOnInit(): void {}

	reloadUnits() {
		this.reloadEventEmitter.emit();
	}

}
